import React, { useEffect, useState } from 'react'
import Card from '../../../Components/Card/Card'
import Loader from '../../../Components/Loader/Loader'

import { getResumenConsumoProductosBodega } from '../../../../Base/API/Inventarios/BodegaMateriales/BodegaMaterialesRequests'
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid'
import { Button } from 'primereact/button'

import { mounths } from '../../../../Base/Services/FechasService'

const ResumenConsumoProductosScreen = ({IPS}) => {

    const [data, setData] = useState()
    const [loading, setLoading] = useState()
    const [cols, setCols] = useState([])
    const [anual, setAnual] = useState(true)


    const getInfo = async () => {
        setData([])
        setLoading(true)
        const a = await getResumenConsumoProductosBodega(anual ? 1 : 0, IPS)
        console.log(a);
        setData(a)
        setLoading(false)
    }

    const colums = [
        {
            field: 'IdProductoSuministro',
            header: 'IdProductoSuministro',
            headerEn: '',
            className: 'XXsmall',
            frozen: 'true',
            alignFrozen: 'left',
        },
        
        {
            field: 'CodigoProducto',
            header: 'Codigo',
            headerEn: '',
            className: 'small',
            frozen: 'true',
            alignFrozen: 'left',
        },
        {
            field: 'NombreProducto',
            header: 'NombreProducto',
            headerEn: '',
            className: 'XXlarge',
            frozen: 'true',
            alignFrozen: 'left',
            Sumary: 'count'
        },
        {
            field: 'CategoriaFinanzas',
            header: 'Categoria',
            headerEn: '',
            className: 'small',
            frozen: 'true',
            alignFrozen: 'left',
        },
        {
            field: 'UnitName',
            header: 'Unidad Compra',
            headerEn: '',
            className: 'small',
            Format:'Center'
        },
        {
            field: 'UnitName',
            header: 'Unidad Despacho',
            headerEn: '',
            className: 'small',
            Format:'Center'
        },
        {
            field: 'Antiguedad',
            header: 'Antiguedad',
            headerEn: '',
            className: '',
        },
        
        {
            field: 'Minimo',
            header: 'Minimo',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            // Sumary: 'sum',
        },
        {
            field: 'Maximo',
            header: 'Maximo',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            // Sumary: 'sum',
        },
        {
            field: 'FechaVencimiento',
            header: 'Fecha Vencimiento',
            headerEn: '',
            className: '',
        },
        ...cols
    ]

    const table = {
        Columns: colums,
        Data: data,
        // pivotMode: true,
        // pivotExpanded: -1,
        // pivotRowTotals: 'after',
        // pivotPanelShow: 'always'
        // sideBar: 'columns',
        // groupDisplayType: 'multipleColumns'
    }


    useEffect(() => {
        setCols([])
        getInfo()
        const year = (new Date()).getFullYear();
        let cols = []
        console.log({anual});
        if (anual) {
            for (let i = year - 2; i <= year; i++) {
                cols.push(
                    {
                       headerName: i,
                       children: [
                        {
                            field: i + 'I',
                            header: 'Ingreso',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: i + 'IM',
                            header: 'Costo L',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: i + 'S',
                            header: 'Salidas',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                        {
                            field: i + 'SM',
                            header: 'Costo L',
                            headerEn: '',
                            className: 'small',
                            Format: 'Currency',
                            Sumary: 'sum',
                        },
                    ]
                    },
                )
            }

        } else {
            const month = (new Date()).getMonth()
            for (let i = year - 2; i <= year; i++) {
                let meses = []
                mounths.forEach((m) => {
                    if (i <= year && m.month <= (month - 1)) {
                        meses.push({
                            headerName: m.es,
                            children: [
                                {
                                    field: m.es + '-' + i + 'I',
                                    header: 'Ingreso',
                                    headerEn: '',
                                    className: 'small',
                                    Format: 'Currency',
                                    Sumary: 'sum',
                                },
                                {
                                    field: m.es + '-' + i + 'IM',
                                    header: 'Costo L',
                                    headerEn: '',
                                    className: 'small',
                                    Format: 'Currency',
                                    Sumary: 'sum',
                                },
                                {
                                    field: m.es + '-' + i + 'S',
                                    header: 'Salidas',
                                    headerEn: '',
                                    className: 'small',
                                    Format: 'Currency',
                                    Sumary: 'sum',
                                },
                                {
                                    field: m.es + '-' + i + 'SM',
                                    header: 'Costo L',
                                    headerEn: '',
                                    className: 'small',
                                    Format: 'Currency',
                                    Sumary: 'sum',
                                },
                            ]
                        })
                    }
                })
                cols.push({
                    headerName: i,
                    children: meses
                },)
            }
        }
        console.log(cols);
        setCols(cols)
    }, [anual])

    return (
        <div>
            <Card
                titulo={<div className='d-flex gap'>
                    <h3>Resumen Consumo de productos</h3>
                    <Button
                        icon='pi pi-refresh'
                        onClick={getInfo}
                    />
                    <Button
                        label={'Cambiar a ' + (anual ? 'Mensual' : 'Anual')}
                        onClick={e => { setAnual(!anual) }}
                    />
                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }}>
                    <Loader loading={loading} />
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default ResumenConsumoProductosScreen